// src/components/Navbar.tsx
import React from 'react';
import '../styles/Navbar.css'; // Import component-specific styles

const Navbar: React.FC = () => {
  return (
    <header className="govuk-header" role="banner">
      <div className="govuk-header__container govuk-width-container">
        <div className="govuk-header__logo">
          <a href="/" className="govuk-header__link govuk-header__link--homepage">
            <span className="govuk-header__logotype">Schema Editor</span>
          </a>
        </div>
      </div>
    </header>
  );
};

export default Navbar;
